import { render, staticRenderFns } from "./onlitform.vue?vue&type=template&id=a57a1f38&scoped=true&"
import script from "./onlitform.vue?vue&type=script&lang=js&"
export * from "./onlitform.vue?vue&type=script&lang=js&"
import style0 from "./onlitform.vue?vue&type=style&index=0&id=a57a1f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a1f38",
  null
  
)

export default component.exports